import fs from 'fs';
import moment from 'moment';
import React from 'react';

const ModalFooter = props =>
  <div className="modal-footer">
    <button type="button" className="btn" data-dismiss="modal">
      Close
    </button>
    <button
      type="button"
      className={'btn ' + (props.btnClass || 'btn-primary')}
      data-dismiss={props.modalRef ? '' : 'modal'}
      onClick={props.onSave}
    >
      {props.modalConfirmText}
    </button>
  </div>;

export const withModalBody = ModalBody => props =>
  <div
    className="modal fade"
    id={props.modalName}
    tabIndex="-1"
    role="dialog"
    aria-labelledby={props.modalName}
    aria-hidden="true"
    ref={props.modalRef}
  >
    <div className="modal-dialog" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" style={{ display: 'inline-block' }}>
            {props.modalTitle}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ModalBody {...props} />
        {!props.noFooter && <ModalFooter {...props} />}
      </div>
    </div>
  </div>;

const randomCode = '3913472r59n9t738x291';

export function decoder(code) {
  const decoded = Buffer.from(code, 'base64').toString();
  const str = decoded.substr(randomCode.length);
  return str;
}

export function encoder(str) {
  return Buffer.from(randomCode + str).toString('base64');
}

export const copyFile = (source, target) =>
  new Promise((resolve, reject) => {
    let cbCalled = false;
    function done(err) {
      if (!cbCalled) {
        cbCalled = true;
        if (err) {
          reject(err);
        } else {
          resolve();
        }
      }
    }

    const rd = fs.createReadStream(source);
    rd.on('error', err => done(err));
    const wr = fs.createWriteStream(target);
    wr.on('error', err => done(err));
    wr.on('close', err => done(err));
    rd.pipe(wr);
  });

export function weekDayToDate(year, month, week, day) {
  const yearNum = parseInt(year, 10);
  const weekNum = parseInt(week, 10);
  const dayNum = parseInt(day, 10);
  // first day of month should not be sunday
  let firstDayOfMonth = moment(`${month}-${yearNum}`, 'MMMM-YYYY').utc();
  if (firstDayOfMonth.day() === 0) {
    firstDayOfMonth = firstDayOfMonth.add(1, 'day');
  }
  const isoweek = parseInt(firstDayOfMonth.format('WW'), 10) + weekNum - 1;
  const date = moment()
    .year(yearNum)
    .week(isoweek)
    .day(dayNum)
    .startOf('day')
    .utc();

  if (date.format('MMMM') !== month) {
    return -1;
  }
  return date;
}

export function imagePath(path) {
  return path && !path.startsWith('data') && !path.startsWith('/uploads')
    ? `/uploads/${path}`
    : path;
}

export function getYoutubeToken(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : null;
}



// WEBPACK FOOTER //
// ./src/utils/util.js